import gql from "graphql-tag";

export const UPDATE_BACKLOG_GROUP = gql`
  mutation updateBacklogGroup($input: updateBacklogGroupInput) {
    updateBacklogGroup(input: $input) {
      _id
    }
  }
`;
